export default "__VITE_ASSET__CKjxKS_4__"